
export const actions = {
    UPDATE_TENANTS: "UPDATE_TENANTS",
};

export interface ITenantCreate {
    tenantsUpdated:boolean
}

const stateObj: ITenantCreate = {
    tenantsUpdated:false
};

export default (state = stateObj, action: { type: string, payload: any }) => {
    state = {...state};
    switch (action.type) {
        case actions.UPDATE_TENANTS:
            state.tenantsUpdated = action.payload;
            return state;
            default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./app/reducers/tenant.ts